ConnectStore = require 'components/enhancers/connect_store'
DocumentSectionsV2Actions = require 'actions/document_sections_v2_actions'
MdaHandoutExtraActions = require 'components/mda/handouts/mda_handout_extra_actions'
MiniDSActions = require 'actions/mini_ds_actions'
MiniDSStore = require 'stores/mini_ds_store'
MiniDocumentModal = require 'components/mini_ds/mini_document_modal'
mediator = require 'mediator'
ProgressSelect = require 'components/evidence_syntheses/progress_select'
QuestionsStatusesStore = require 'stores/questions_statuses_store'
{ MDA_HANDOUT } = require 'lib/db_docs/doc_types'
{ isCurrentUserAdmin } = require 'lib/members_helper'
{ DOCUMENT_STATUSES } = require 'lib/document_sections_v2_helper'
{ useCallback, useState } = React
{ Button } = ReactComponents
{ useCoffeeCallback, useI18n, useCoffeeMemo } = require 'lib/react_utils'

storeConnector =
  QuestionsStatusesStore: (Store, props) ->
    questionStatuses: Store.getQuestionStatuses props.currentDocumentId
  MiniDSStore: (Store) ->
    createOrEditDialogOpen: Store.isCreateOrEditDialogOpen()
    documentName: Store.getCurrentDocumentName()

MiniDSToolbar = ({
  createOrEditDialogOpen
  currentDocumentId
  questionStatuses
  documentName
  documentType
}) ->

  namespace = if documentType is MDA_HANDOUT then 'mda:handouts' else 'docsec:mini_ds'

  i18n = useI18n(namespace)
  userAccessRights = mediator.user.getAccessRights()
  isAdmin = useCoffeeMemo [userAccessRights], -> _.contains(userAccessRights, 'admin')

  openCreateOrEditDialog = useCoffeeCallback [], -> MiniDSActions.openCreateOrEditDialog()

  <div className="flex flex-row mx-10">
    <h2 className="flex-grow">
      {if documentName then documentName else i18n('toolbar_title')}
    </h2>
    <div>
      <div className="flex flex-row items-center">
        {!_.isEmpty(currentDocumentId) and <Button
          className="mr-5"
          onClick={DocumentSectionsV2Actions.expandAllChapters}
          >
            {i18n '/actions.expand_all'}
          </Button>
        }
        {documentType is MDA_HANDOUT and not _.isEmpty(currentDocumentId) and
          <div className="mr-5">
            <MdaHandoutExtraActions handoutId={currentDocumentId} />
          </div>
        }
        <ProgressSelect
          questionId={currentDocumentId}
          questionStatuses={questionStatuses}
          showLabel={false}
          statusesList={DOCUMENT_STATUSES}
          groupKey='documentStatus'
          withCompleted={false}
          editable={isAdmin}
        />
        {isCurrentUserAdmin() and _.isEmpty(currentDocumentId) and  <div className="flex flex-row">
          <Button
            className="btn btn-apply"
            label={i18n 'new_document'}
            onClick={openCreateOrEditDialog}
          />
        </div>}
        {createOrEditDialogOpen and <MiniDocumentModal documentType={documentType} />}
      </div>
    </div>
  </div>

MiniDSToolbar.propTypes =
  createOrEditDialogOpen: PropTypes.bool.isRequired
  currentDocumentId: PropTypes.string
  questionStatuses: PropTypes.object.isRequired
  documentName: PropTypes.string
  documentType: PropTypes.oneOf([MDA_HANDOUT, 'mini_ds']).isRequired

module.exports = ConnectStore MiniDSToolbar,
  [MiniDSStore, QuestionsStatusesStore], storeConnector
